<template>
    <DropDownMenu v-if="currentClock != null" :menus="menus"></DropDownMenu>
</template>

<script>
    import Vue from 'vue';
    import Translations from '@/store/translations';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store/index.js'
    import DropDownMenu from'@/components/common/DropDownMenu.vue';
    import EventBus from '@/eventbus';

    export default {
        name: "ClockActions",
        store,
        components: {
            DropDownMenu
        },
        computed: {
            Translations: () => Translations,
            ...mapState({
                currentClock: state => state.currentClock,
                isLoadingClock: state => state.loadingStates.isLoadingBox
            }),
        },
        data() {
            return {
                menus: [
                    {
                        external: true,
                        iconClass: "fa-cog",
                        title: Translations.sections.clocks.details.actions.edit,
                        action: this.startEditClock
                    },
                    {
                        external: false, iconClass: "fa-cog",
                        title: Translations.sections.clocks.details.actions.edit,
                        action: this.startEditClock
                    },
                    {
                        external: false, iconClass: "fa-clone",
                        title: Translations.sections.clocks.details.actions.duplicate || "Duplicate",
                        action: this.startDuplicateClock
                    },
                    { external: false, isDivider: true },
                    {
                        external: false, iconClass: "fa-trash-alt",
                        title: Translations.sections.clocks.details.actions.delete,
                        action: this.startDeleteClock
                    },
                ]
            }
        },
        methods: {
            startDeleteClock(e) {
                EventBus.$emit("onClockRemove");
            },
            startDuplicateClock(e) { EventBus.$emit("onClockDuplicate", this.currentClock.uid); },
            startEditClock(e) { EventBus.$emit("onClockEdition", this.currentClock.uid); },
        }
    }
</script>

<style scoped>
</style>
